const initialState = {
    leadSources: [],
    isReadingLeadSources: false
}

export default initialState;
